import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { onboardingQueryKeyFactory } from "../queryKeyFactory";

export function useOnboardingSignalsInfoQuery(isEnabled: boolean) {
    return useQuery<OnboardingSignalsInfoData>({
        enabled: isEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: onboardingQueryKeyFactory.onboardingSignalsInfoData(),
        throwOnError: true,
        queryFn: async (): Promise<OnboardingSignalsInfoData> => {
            return await salesApiService.onboarding.fetchOnboardingSignalsInfoData();
        },
    });
}
